import { useQuery } from '@tanstack/react-query';
import { brandsAPI } from '../services/api';
import { useLanguage } from '../contexts/LanguageContext';

export const useBrands = (params = {}) => {
  const { language } = useLanguage();

  // Merge language into params
  const queryParams = { ...params, lang: language };

  return useQuery({
    queryKey: ['brands', queryParams], // Include lang in cache key
    queryFn: () => brandsAPI.getBrands(queryParams),
    staleTime: 1000 * 60 * 30 // 30 minutes - brands don't change often
  });
};
